import { on } from 'delegated-events';
import AvailabilityPopup from './availability-popup';
import { debounce } from './utils/utils';

const variantsCache = new WeakMap();
let lastWidth = window.innerWidth;

export default function () {
    initCustomSliders();
    initVariantChanging();
    AvailabilityPopup();

    document.addEventListener('DOMContentLoaded', () => {
        overflowControlInit();
    });
    document.addEventListener('pjax:complete', () => {
        overflowControlInit()
    });
    window.addEventListener('resize', debounce(function () {
        const currentWidth = window.innerWidth;
        if (currentWidth === lastWidth) return;
        lastWidth = currentWidth;

        overflowControlInit()
    }, 100));
}

function overflowControlInit() {
    requestAnimationFrame(() => {
        requestAnimationFrame(overflowControl);
    });
}
function overflowControl() {
    document.querySelectorAll('.product').forEach(product => {
        let variantsContainer = product.querySelector('.product-variants');
        let variantsUl = product.querySelector('.product-variants > ul');
        const countContainer = variantsContainer.querySelector('.accordion-trigger > b');

        if (!variantsContainer || !variantsUl || !countContainer) return;

        countContainer.parentElement.classList.remove('info-visible');
        if (variantsUl.scrollHeight > variantsContainer.scrollHeight) {
            variantsContainer.classList.add('overflowing');
        } else {
            variantsContainer.classList.remove('overflowing');
        }

        let overflownVariants = 0;
        const containerRect = variantsContainer.getBoundingClientRect();
        variantsUl.querySelectorAll("& > li").forEach(li => {
            const childRect = li.getBoundingClientRect();
            if (childRect.top >= (containerRect.bottom - 1)) overflownVariants++;
        });

        countContainer.innerText = (overflownVariants === 0 ? '' : overflownVariants);
    });
}

function hydrateSlider(slider) {
    slider.querySelectorAll('img[data-custom-lazyload]').forEach(img => {
        const replacement = img.dataset.customLazyload;
        if (!replacement) return;
        img.src = replacement;
    });
}

function initCustomSliders() {
    document.querySelectorAll('.slides-container').forEach(container => {
        container.scrollLeft = 0;
    });

    ['mouseover', 'touchstart', 'focusin'].forEach(eventName => {
        on(eventName, '.custom-slider', function () {
            hydrateSlider(this);
        });
    });

    on('click', '.custom-slider > button', function () {
        const slider = this.closest('.custom-slider');
        const slidesContainer = slider.querySelector('.slides-container');
        const direction = this.classList.contains('custom-slider-prev') ? -1 : 1;

        if ((slider.classList.contains('reached-start') && direction === -1)
            || (slider.classList.contains('reached-end') && direction === 1)) return;

        hydrateSlider(slider);

        slidesContainer.scrollBy({
            left: direction * (slidesContainer.clientWidth + 10),
            behavior: 'smooth'
        });
    });

    on('scrollend', '.custom-slider', function () {
        const slider = this;
        const slidesContainer = slider.querySelector('.slides-container');

        slider.classList.remove('reached-start');
        slider.classList.remove('reached-end');

        if (slidesContainer.scrollLeft - 1 <= 0)
            return slider.classList.add('reached-start');

        if (slidesContainer.scrollLeft + slidesContainer.clientWidth + 1 >= slidesContainer.scrollWidth)
            slider.classList.add('reached-end');

    }, { capture: true });
}

function fetchVariant(product, variantId) {
    let variants = variantsCache.get(product);
    if (!variants) {
        variants = new Map();
        variantsCache.set(product, variants);
    }

    if (!variants.has(variantId)) {
        const pid = product.querySelector('[data-pid]').getAttribute('data-pid');
        // podglad /promocja/test: ceny z symulowanych promocji
        const preview = window.location.pathname.replace(/\/$/, '') === '/promocja/test' ? '&preview=1' : '';

        const request = fetch(`/listing_variant?pid=${pid}&oid=${variantId}${preview}`, { credentials: 'same-origin' })
            .then(response => {
                if (!response.ok) throw new Error(`listing_variant ${response.status}`);
                return response.json();
            })
            .catch(error => {
                variants.delete(variantId);
                throw error;
            });

        variants.set(variantId, request);
    }

    return variants.get(variantId);
}

function initVariantChanging() {
    on('click', '.product-variants li[data-variant-id]', function () {
        if (this.classList.contains('selected')) return;

        const product = this.closest('.product');
        const variantId = this.dataset.variantId;
        const previous = product.querySelector('.product-variants li.selected');

        const select = chip => {
            product.querySelectorAll('.product-variants li.selected').forEach(li => li.classList.remove('selected'));
            if (!chip) return;

            chip.classList.add('selected');
            setChosenOption(product, chip.dataset.variantId, !chip.classList.contains('unavailable'));
        };

        select(this);
        product.dataset.pendingVariant = variantId;

        fetchVariant(product, variantId)
            .then(data => {
                if (product.dataset.pendingVariant !== variantId) return;
                replaceProductInfo(+variantId, product, data);
            })
            .catch(error => {
                console.log(error);
                if (product.dataset.pendingVariant !== variantId) return;
                select(previous);
            });
    });
}

function setChosenOption(product, optionId, available) {
    product.classList.toggle('cart-disabled', !available);

    const cartButton = product.querySelector('[data-optionid]');
    if (cartButton) cartButton.setAttribute('data-optionid', optionId);
}

function replaceProductInfo(chosenId, product, data) {
    product.classList.add('changed-variant');
    setChosenOption(product, chosenId, data.available);

    replaceBadges(product, data);
    replaceImages(product, data);
    replaceNameHref(product, data);
    replacePrice(product, data);
    setText(product, '[data-replace="sku"]', data.sku);
}

function setText(product, selector, value) {
    const element = product.querySelector(selector);
    if (element) element.textContent = value || '';
}

function replaceBadges(product, data) {
    const badgesContainer = product.querySelector('[data-replace="badges"]');
    if (!badgesContainer) return;

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            badgesContainer.textContent = '';

            (data.badges || []).forEach(b => {
                const badge = document.createElement('span');
                badge.textContent = b.text;
                badge.classList.add(`badge-${b.class}`);
                badgesContainer.appendChild(badge);
            });
        });
    });
}

function replaceImages(product, data) {
    const slidesContainer = product.querySelector('[data-replace="images"] .slides-container');
    if (!slidesContainer || !data.images || data.images.length === 0) return;

    const template = slidesContainer.querySelector('img');
    const width = template ? template.getAttribute('width') : null;
    const height = template ? template.getAttribute('height') : null;

    slidesContainer.textContent = '';

    data.images.forEach((image, i) => {
        const figure = document.createElement('figure');
        figure.classList.add('product-image');
        const img = document.createElement('img');

        if (i === 0) {
            img.src = image.src;
        } else {
            img.className = 'custom-lazyload';
            img.dataset.customLazyload = image.src;
        }

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                img.classList.add('img-added');
            });
        });

        img.alt = image.alt;
        if (width) img.setAttribute('width', width);
        if (height) img.setAttribute('height', height);

        figure.appendChild(img);
        slidesContainer.appendChild(figure);
    });

    slidesContainer.scrollLeft = 0;
}

function replaceNameHref(product, data) {
    const name = product.querySelector('[data-replace="name"]');
    if (!name) return;

    const skuString = data.sku ? ` | SKU ${data.sku}` : '';

    name.textContent = data.name;
    name.title = `${data.name}${skuString}`;
    name.setAttribute('href', data.href);
}

function replacePrice(product, data) {
    const priceContainer = product.querySelector('.product-price');
    setText(product, '[data-replace="price"]', data.price);

    const prevOldPrice = priceContainer.querySelector('del');
    if (prevOldPrice) prevOldPrice.remove();

    if (!data.oldprice) return;

    const oldPrice = document.createElement('del');
    oldPrice.textContent = data.oldprice;
    priceContainer.appendChild(oldPrice);
}